// extracted by mini-css-extract-plugin
module.exports = {"button":"Rocket_button__eXM7s","full-width-avatar":"Rocket_full-width-avatar__34tgu","image":"Rocket_image__2yIvg","fly":"Rocket_fly__37bK9"};